__turbopack_context__.v({
  "ErrorMessage": "Form-module-scss-module__PalS3q__ErrorMessage",
  "Submit": "Form-module-scss-module__PalS3q__Submit",
  "Success": "Form-module-scss-module__PalS3q__Success",
  "Title": "Form-module-scss-module__PalS3q__Title",
});
